export interface FormResult {
  ok: boolean;
  message: string;
}

function extractServerMessage(responseText: string): string {
  try {
    const parsed = JSON.parse(responseText) as {
      code?: string;
      message?: string;
      meta?: { message?: string; detail?: string };
    };
    const msg =
      parsed?.meta?.message ||
      parsed?.message ||
      parsed?.meta?.detail ||
      responseText;
    return msg || '';
  } catch {
    return responseText;
  }
}

export async function postForm(
  submitAddr: string,
  form: HTMLFormElement,
  successMessage: string
): Promise<FormResult> {
  const fd = new FormData(form);

  // 蜜罐校验：命中则返回与正常提交一致的通用反馈，避免泄露机器人线索
  const honeypot = fd.get('website_alt');
  if (honeypot && typeof honeypot === 'string' && honeypot.trim() !== '') {
    return { ok: true, message: successMessage };
  }
  fd.delete('website_alt');

  const body = new URLSearchParams();
  fd.forEach((value, key) => {
    if (typeof value === 'string') {
      body.append(key, value);
    }
  });

  try {
    const res = await fetch(submitAddr, {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: body.toString(),
    });
    const responseText = await res.text();
    const serverMsg = extractServerMessage(responseText);
    const isSpam = /spam/i.test(serverMsg);
    const success = res.ok && responseText.includes('"code":"OK"') && !isSpam;
    if (success) {
      return { ok: true, message: successMessage };
    }
    return { ok: false, message: serverMsg || '提交失败，请稍后再试。' };
  } catch {
    return { ok: false, message: '网络异常，请稍后再试。' };
  }
}